// Types
export interface ApiRes<T = undefined> {
  success: boolean;
  error?: string;
  data?: T;
}

// Error Messages
const ERROR_MESSAGES = {
  register: {
    email: 'El email ya fue registrado previamente',
    password: 'La contraseña no cumple los requisitos',
    default: 'Error en el registro, intenta nuevamente',
  },
  password: {
    email: 'El email ingresado no está registrado',
    expired: 'El enlace de recuperación ha expirado',
    default: 'Error en la recuperación, intenta nuevamente',
  },
  generic: 'Error inesperado, intenta nuevamente',
} as const;

type ErrorContext = keyof Omit<typeof ERROR_MESSAGES, 'generic'>;

// Error Handler
const mapError = (error: string | undefined, context: ErrorContext): string => {
  if (!error) return ERROR_MESSAGES[context].default;

  const contextMessages = ERROR_MESSAGES[context];
  const errorLower = error.toLowerCase();

  const matchedKey = Object.keys(contextMessages).find(
    (key) => key !== 'default' && errorLower.includes(key),
  );

  return matchedKey
    ? contextMessages[matchedKey as keyof typeof contextMessages]
    : contextMessages.default;
};

export const handleAuthRequest = async <T>(
  request: () => Promise<{ success: boolean; error?: string; data?: T }>,
  context: ErrorContext,
): Promise<ApiRes<T>> => {
  try {
    const { success, error, data } = await request();
    if (success) return { success: true, data };
    return { success: false, error: mapError(error, context) };
  } catch (error) {
    console.error(`${context} failed:`, error);
    return { success: false, error: ERROR_MESSAGES.generic };
  }
};
